import {AlertItem, CountItem} from '../typedef';

import {mergeSavedContentData} from './merge-saved-content-data';

type ListItem = {
    id: string | number,
    name: string,
    listType: string,
    auditStatistic?: {
        createdAt?: string,
        lastRunAt?: string,
        lastSharedAt?: string,
        lastUpdatedAt?: string,
    },
};

export const mergeSavedListsData = (listsArray: ListItem[], alerts: AlertItem[], countsData: CountItem[]) => {
    return mergeSavedContentData(
        listsArray,
        alerts,
        countsData,
        {
            getId: (item: ListItem) => item.id,
            getName: (item: ListItem) => item.name,
            getSearchType: (item: ListItem) => item.listType,
            getAuditStatistic: (item: ListItem) => item.auditStatistic,
            getCountKey: (count: CountItem) => count.savedSearchId,
            getCountValues: (count: CountItem) => ({alertCount: count.alertCount, totalCount: count.searchTotalCount}),
        },
    );
};
